import { z } from "zod";
import { CompanyInfoResponseSchema, LandingUserInfoResponseSchema, PageableSchema } from "./shared";
import { UserInfoResponseSchema } from "./shared";
import { RouterEntitySchema } from "./router";
import { MachineEntitySchema } from "./machine";

export const GetRequestedCompanyResponseSchema = PageableSchema(LandingUserInfoResponseSchema);

export type GetRequestedCompanyResponse = z.infer<
  typeof GetRequestedCompanyResponseSchema
>;

export const CompanyDetailResponseSchema = z.object({
  company: CompanyInfoResponseSchema,
  companyAdmin: UserInfoResponseSchema,
  routers: z.array(RouterEntitySchema),
  devices: z.array(MachineEntitySchema)
})

export type CompanyDetailResponse = z.infer<typeof CompanyDetailResponseSchema>;